module.exports = __webpack_public_path__ + "img/sample2.fc05ba07.jpeg";